import React, { useEffect, useState } from 'react';
import SelectInput from '../../Input/SelectInput';
import Select from 'react-select';

export default function TagInputs(props) {
    // Get the current date in 'YYYY-MM-DD' format
    const currentDate = new Date().toISOString().split('T')[0];

    // Determine the date restrictions based on the `dateRestriction` prop
    let minDate, maxDate;
    if (props?.type === 'time') {
        minDate = props?.min || '';
    } else {
        if (props.dateRestriction === 'current') {
            minDate = currentDate;
            maxDate = currentDate;
        } else if (props.dateRestriction === 'past') {
            maxDate = currentDate;
        } else if (props.dateRestriction === 'future') {
            minDate = currentDate;
        }
    }

    const isMobile = window.innerWidth < 768;
    const showLabel = !isMobile && props.label;
    const placeholder = isMobile ? props.label : props.placeholder;

    return (
        <div className='m-t-10'>
            <div className='flex' style={{ gap: '0' }}>
                {showLabel &&
                    <div 
                        className={`${props.type === 'textArea' ? 'label-textarea' : 'label-box'} ${props.className}`}
                        style={{
                            background: 'linear-gradient(135deg, #2d5a24 0%, #3c7e2d 100%)',
                            color: '#EBFFE6',
                            padding: '12px 16px',
                            borderRadius: '8px 0 0 8px',
                            fontWeight: '600',
                            fontSize: '14px',
                            letterSpacing: '0.3px',
                            display: 'flex',
                            alignItems: 'center',
                            minWidth: 'fit-content',
                            boxShadow: '0 2px 4px rgba(45, 90, 36, 0.1)'
                        }}
                    >
                        {props.label}
                    </div>
                }
                { props.type === 'select' ? (
                    <SelectInput
                        onChange={props.onChange}
                        disabled={props.disabled}
                        value={props.value}
                        name={props.name}
                        options={props?.options}
                        className="w-100"
                        style={{
                            border: "2px solid #3c7e2d",
                            width: "100%",
                            height:"45px",
                            borderRadius: showLabel ? "0 8px 8px 0" : "8px",
                            // paddingRight: "20px",
                            background: "#EBFFE6",
                            transition: "all 0.3s ease",
                            fontSize: "14px"
                        }}
                    />

                ) : (
                    props.type === 'R-select' ? (
                        <Select
                            name={props.name}
                            id={props.name}
                            value={props.value}
                            onChange={props.onChange}
                            onBlur={props.onBlur}
                            isDisabled={props.disabled}
                            placeholder={placeholder}
                            options={props.options}
                            menuShouldScrollIntoView={false}
                            styles={{
                                container: (provided) => ({
                                    ...provided,
                                    width: '100%',
                                }),
                                control: (provided, state) => ({
                                    ...provided,
                                    padding: '4px 8px',
                                    border: state.isFocused ? '2px solid #3c7e2d' : '2px solid #a8d89f',
                                    borderRadius: showLabel ? '0 8px 8px 0' : '8px',
                                    background: '#EBFFE6',
                                    boxShadow: state.isFocused ? '0 0 0 3px rgba(60, 126, 45, 0.1)' : 'none',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        borderColor: '#3c7e2d'
                                    }
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    maxHeight: '250px',
                                    borderRadius: '8px',
                                    border: '2px solid #a8d89f',
                                    boxShadow: '0 4px 12px rgba(45, 90, 36, 0.15)',
                                    overflow: 'hidden'
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    background: state.isSelected ? '#3c7e2d' : state.isFocused ? '#d4f5cc' : '#EBFFE6',
                                    color: state.isSelected ? '#EBFFE6' : '#2d5a24',
                                    padding: '10px 12px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease'
                                }),
                                multiValue: (provided) => ({
                                    ...provided,
                                    background: '#3c7e2d',
                                    borderRadius: '4px'
                                }),
                                multiValueLabel: (provided) => ({
                                    ...provided,
                                    color: '#EBFFE6',
                                    fontWeight: '500'
                                }),
                                multiValueRemove: (provided) => ({
                                    ...provided,
                                    color: '#EBFFE6',
                                    '&:hover': {
                                        background: '#2d5a24',
                                        color: '#fff'
                                    }
                                })
                            }}
                            isMulti={props?.isMulti}
                        />

                    ) : (
                        <div style={{
                            width: "100%",
                            position: 'relative'
                        }}>
                            {props.type === "date" || props.type === "time" ? (
                                <input
                                    onChange={props.onChange}
                                    name={props.name}
                                    disabled={props.disabled}
                                    readOnly={props.readOnly}
                                    value={props.value}
                                    type={props.type}
                                    min={minDate}
                                    max={maxDate}
                                    className="w-100"
                                    placeholder={placeholder}
                                    style={{
                                        padding: '12px 16px',
                                        border: '2px solid #a8d89f',
                                        borderRadius: showLabel ? '0 8px 8px 0' : '8px',
                                        background: '#EBFFE6',
                                        fontSize: '14px',
                                        color: '#2d5a24',
                                        transition: 'all 0.3s ease',
                                        outline: 'none',
                                        fontFamily: 'inherit'
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#3c7e2d';
                                        e.target.style.boxShadow = '0 0 0 3px rgba(60, 126, 45, 0.1)';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#a8d89f';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                />
                            ) : props.type === "textArea" ? (
                                <textarea
                                    onChange={props.onChange}
                                    rows={3}
                                    value={props.value}
                                    name={props.name}
                                    readOnly={props.readOnly}
                                    disabled={props.disabled}
                                    placeholder={placeholder}
                                    style={{
                                        width: "100%",
                                        padding: '12px 16px',
                                        border: '2px solid #a8d89f',
                                        borderRadius: showLabel ? '0 8px 8px 0' : '8px',
                                        background: '#EBFFE6',
                                        fontSize: '14px',
                                        color: '#2d5a24',
                                        transition: 'all 0.3s ease',
                                        outline: 'none',
                                        fontFamily: 'inherit',
                                        resize: 'vertical'
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#3c7e2d';
                                        e.target.style.boxShadow = '0 0 0 3px rgba(60, 126, 45, 0.1)';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#a8d89f';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                />
                            ) : (
                                <input
                                    onChange={props.onChange}
                                    name={props.name}
                                    disabled={props.disabled}
                                    placeholder={placeholder}
                                    readOnly={props.readOnly}
                                    value={props.value}
                                    type={props.type === "password" ? "password" : (props?.variation ? "number" : "text")}
                                    step={props.variation ? "any" : undefined}
                                    className="w-100"
                                    style={{
                                        ...props?.style,
                                        padding: '12px 16px',
                                        border: '2px solid #a8d89f',
                                        borderRadius: showLabel ? '0 8px 8px 0' : '8px',
                                        background: '#EBFFE6',
                                        fontSize: '14px',
                                        color: '#2d5a24',
                                        transition: 'all 0.3s ease',
                                        outline: 'none',
                                        fontFamily: 'inherit'
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#3c7e2d';
                                        e.target.style.boxShadow = '0 0 0 3px rgba(60, 126, 45, 0.1)';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#a8d89f';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                />
                            )}
                        </div>
                    )
                )}
            </div>
        </div>
    );
}